import { Collapse, Heading, useDisclosure } from "@chakra-ui/react";
import { ExpandChevron } from "../../elements/ExpandChevron";
import { EnergyMeasureTable } from "../../components/EnergyMeasureTable";
import { PriceCommentTable } from "../../components/PriceCommentTable";

export function CompareEnergyMeasureTable() {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });

  return (
    <>
      <Heading
        cursor="pointer"
        mb={isOpen ? 0 : 4}
        ml={6}
        onClick={onToggle}
        size="xs"
        w="max-content"
      >
        <ExpandChevron forHeading isOpen={isOpen} />
        Energetische maatregelen
      </Heading>
      <Collapse in={isOpen}>
        <EnergyMeasureTable />
        <PriceCommentTable />
      </Collapse>
    </>
  );
}
